import type { AnalyticsEventProperties } from "@-/dev.improve.haniverse.lib.analytics";

/**
 * String settings whose values are a closed set of choices. Every other string setting (tone color
 * names and hex codes, JSON blobs) reports only that it changed, never its value.
 */
const ENUM_SETTING_KEYS = new Set<string>([
  "hanziScript",
  "hskVersion",
  "pinyinKeyboardLayout",
  "reviewMode",
  "weekStartsOn",
]);

function toSnakeCase(key: string): string {
  return key.replaceAll(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

/**
 * The `settings_changed` properties for a saved settings patch: every changed key, plus the new
 * value of each boolean, number and enum setting (snake_cased).
 */
export function settingsChangedAnalyticsProperties(
  values: object,
): AnalyticsEventProperties["settings_changed"] {
  const keys = Object.keys(values).sort((a, b) => a.localeCompare(b));
  const properties: AnalyticsEventProperties["settings_changed"] = {
    keys: keys.map((key) => toSnakeCase(key)),
  };
  for (const key of keys) {
    const value: unknown = Reflect.get(values, key);
    if (
      typeof value === "boolean" ||
      (typeof value === "number" && Number.isFinite(value)) ||
      (typeof value === "string" && ENUM_SETTING_KEYS.has(key))
    ) {
      properties[toSnakeCase(key)] = value;
    }
  }
  return properties;
}
